import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useVerifyEmailMutation } from "../slices/usersApiSlice";
import { useDispatch } from "react-redux";
import { setCredentials } from "../slices/authApiSlice";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { toast } from "react-toastify";
import { isAuthCookieAccepted, COOKIES_REQUIRED_MESSAGE } from "../utils/authCookieCheck";

export default function VerifyEmailScreen() {
  const { verifyToken } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    async function verify() {
      try {
        const res = await verifyEmail(verifyToken).unwrap();

        // E-mail is verified either way; auto sign-in needs the auth cookie
        if (!(await isAuthCookieAccepted())) {
          setErrorMsg(`Your e-mail address is verified. ${COOKIES_REQUIRED_MESSAGE}`);
          return;
        }

        // Backend returns { message, user }?
        dispatch(setCredentials(res.user));
        toast.success("Success: You are signed in. Welcome to JDiskMark!");
        navigate('/');
      } catch (err) {
        const msg =
          err?.data?.message ||
          err.error ||
          "Error: Invalid or expired verification link";
        setErrorMsg(msg);
      }
    }

    verify();
  }, [verifyToken, verifyEmail, dispatch, navigate]);

  return (
    <div className="mt-5 text-center">
      <h1>E-mail Verification</h1>

      {isLoading && <Loader />}

      {errorMsg && (
        <div className="mt-4">
          <Message variant="danger">{errorMsg}</Message>
        </div>
      )}

      {!isLoading && !errorMsg && (
        <p className="mt-4">Verifying your e-mail…</p>
      )}
    </div>
  );
}